import PropTypes from 'prop-types';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import classNames from 'classnames';

import { updateEventTypes } from '~/features/updateEvents/constants/updateEventTypes';
import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';
import {toShortSemanticVersion, toShortVersion} from '~/features/base/utils/versionNumberConverter';

export const UpdateEventType = ({ value, bundleVersion, deliverableId }) => {
    if (!value) {
        return null;
    }

    const getLabelKey = () => {
        if (value === 'BUNDLE_INSTALL' || value === 'BUNDLE_UPDATE') {
            return deliverableId === 'essential-image'
                ? `intl-msg:deviceUpdateEventType.essentialImage${value === 'BUNDLE_INSTALL' ? 'Install' : 'Update'}`
                : updateEventTypes[value]?.label;
        }
        if (value === 'VOCU_UPDATE') {
            return updateEventTypes[value]?.label;
        }
        return updateEventTypes[value]?.label;
    };

    const label = (
        <span className={classNames('label label-condensed', updateEventTypes[value]?.className)}>
            <FormattedMessage id={getLabelKey()} />
        </span>
    );

    if (!bundleVersion) {
        return label;
    }

    if (deliverableId === 'essential-image') {
        return (
            <OverlayTrigger placement='top' overlay={
                <Tooltip id='tooltip' className='top-right'>
                    Essential Image version: {toShortVersion(bundleVersion)}
                </Tooltip>}>
                {label}
            </OverlayTrigger>
        );
    }

    return (
        <OverlayTrigger placement='top' overlay={
            <Tooltip id='tooltip' className='top-right'>
                Bundle version: {toShortVersion(bundleVersion)}
            </Tooltip>}>
            {label}
        </OverlayTrigger>
    );
};

export default UpdateEventType;

UpdateEventType.propTypes = {
    value: PropTypes.string,
    bundleVersion: PropTypes.string,
};
